import { render } from "./ToolCaptureShoot.vue?vue&type=template&id=2fcd7dc9"
import script from "./ToolCaptureShoot.vue?vue&type=script&lang=js"
export * from "./ToolCaptureShoot.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__